import React from 'react';
import { useNavigate } from 'react-router-dom';
import SurveyTemplateLibrary from './SurveyTemplateLibrary';
import { SurveyTemplate } from '../types/Survey';

const TemplatePage: React.FC = () => {
  const navigate = useNavigate();

  const handleSelectTemplate = (template: SurveyTemplate) => {
    // 선택된 템플릿을 query parameter로 전달하며 SurveyBuilder로 이동
    navigate(`/survey-builder?template=${template.id}`);
  };

  return (
    <div className="page-container">
      <SurveyTemplateLibrary
        onSelectTemplate={handleSelectTemplate}
      />
    </div>
  );
};

export default TemplatePage;